import React from 'react'

import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const SuggestionItemSkeleton = () => {
  return (
    <Box
      padding="s12"
      flexDirection="row"
      justifyContent="spaceBetween"
      borderRadius={{ all: 'abs016' }}
      border={{
        all: {
          style: 'solid',
          width: 's2',
          color: 'grey400',
        },
      }}
    >
      <Box flexDirection="column" gap="s4">
        <Skeleton height="s16" width="s80" />
        <Skeleton height="s12" width="s200" />
        <Skeleton height="s12" width="s240" />
        <Skeleton height="s12" width="s200" />
      </Box>
      <Box flexDirection="row">
        <Skeleton width="s64" height="s24" />
      </Box>
    </Box>
  )
}

export const SuggestionSkeletons = ({
  identifier,
  quantity,
}: {
  identifier: string
  quantity: number
}) => {
  return (
    <>
      {Array.from({ length: quantity }, (_, i) => (
        <SuggestionItemSkeleton key={`${identifier}-${i}`} />
      ))}
    </>
  )
}
